import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center">
      <img src="/logo.png" alt="PRE-IPO EXPERT" className="h-14 w-14 rounded-full object-contain" />
      <p className="mt-8 font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#6D28D9]">404 · Page not found</p>
      <h1 className="font-display mt-4 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">This page isn't on the board</h1>
      <p className="mt-3 max-w-md text-sm text-slate-500">The link may be outdated. Head back to the opportunities board to keep exploring unlisted shares.</p>
      <Link data-testid="not-found-home-link" to="/" className="mt-8 inline-flex items-center gap-2 bg-[#6D28D9] px-6 py-3 font-mono2 text-[11px] font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-[#5B21B6]">
        <ArrowLeft className="h-3.5 w-3.5" /> Back to home
      </Link>
    </div>
  );
}
